"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GatewayService = void 0;
var _gateway = require("../controllers/gateway.controller");
var GatewayService = {
  getUser: _gateway.config.serviceURL + "/get",
  authenticate: _gateway.config.serviceURL + "/authenticate",
  refreshToken: process.env.REACT_APP_CLIENT === "tenant" ? "/recordsservice/v1/api/records/public/refreshtoken?refreshToken=" : _gateway.config.serviceURL + "/refreshToken?refreshToken=",
  ssoToken: "/userservice/v1/api/authenticate/sso?token="
};
exports.GatewayService = GatewayService;